interface GlobalConnectionParams {
  token?: string
}

export const globalConnectionParams: GlobalConnectionParams = {
  token: undefined,
}
